import React, { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import { Menu } from 'lucide-react';
import { useHistory } from '../../hooks/useRouterCompat';
import package_json from "../../../package.json";
import { My } from '../../services/My';
import { UtilApp } from '../../services/Utils/UtilApp';
import { Button } from '../../components/ui/button';
import { useAppUIContext } from '../../context/AppUIContext';

const MainPage: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    if (UtilApp.getParam('office_wave_token')) {
      if (UtilApp.getParam('email') !== My.user.email) {
        console.log(`Current user ${My.user.email} will log out.`);
        My.logoutUser(); // MainPagePublic will handle the relogin.
      } else {
        console.log(`User ${My.user.email} is already logged in. No need to log out.`);
      }
    }
  }, [])

  return (
    <div className="flex flex-col h-full bg-white md:rounded-panel border shadow-sm overflow-hidden">
      <SimpleHeader />
      <div className="flex-1 overflow-y-auto p-4">
        {/* Empty content as per original */}
      </div>
    </div>
  );
};

export const MainPageWelcome: React.FC = () => {
  return (
    <div className="flex flex-col h-full bg-white md:rounded-panel border shadow-sm overflow-hidden">
      <SimpleHeader />
      <div className="flex-1 overflow-y-auto">
        {getWelcomeMsg()}
      </div>
    </div>
  );

  function getWelcomeMsg() {
    return (
      <div className='flex flex-col items-center justify-center h-full text-center p-6 space-y-6'>
        <div className="space-y-2">
          <h3 className="text-2xl font-bold text-gray-900"><Trans>👋 Hi {My.user.name}!</Trans></h3>
          <h3 className="text-xl font-semibold text-gray-700"><Trans>Welcome to NEXTPOD</Trans></h3>
        </div>

        <p className='text-gray-500 max-w-md mx-auto'>
          <Trans>Use the plus button to the left to join or create your first workspace.</Trans>
        </p>

        <div className='flex flex-wrap justify-center gap-4 mt-8'>
          <img src="/assets/img/ic-cha-dolphine-40.svg" className="w-12 h-12 opacity-80 hover:opacity-100 transition-opacity" />
          <img src="/assets/img/ic-cha-cat-40.svg" className="w-12 h-12 opacity-80 hover:opacity-100 transition-opacity" />
          <img src="/assets/img/ic-cha-dog-40.svg" className="w-12 h-12 opacity-80 hover:opacity-100 transition-opacity" />
          <img src="/assets/img/ic-cha-hamster-40.svg" className="w-12 h-12 opacity-80 hover:opacity-100 transition-opacity" />
          <img src="/assets/img/ic-cha-rabbit-40.svg" className="w-12 h-12 opacity-80 hover:opacity-100 transition-opacity" />
          <img src="/assets/img/ic-cha-chick-40.svg" className="w-12 h-12 opacity-80 hover:opacity-100 transition-opacity" />
        </div>
      </div>
    );
  }
};

export const SimpleHeader = (props: any) => {
  const { setIsMobileMenuOpen } = useAppUIContext();

  return (
    <header className="flex items-center px-4 py-3 border-b border-gray-100 min-h-[56px]">
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden mr-2 -ml-2 text-gray-500 hover:text-gray-900"
        onClick={() => setIsMobileMenuOpen(true)}
        data-cy="main-menu"
      >
        <Menu className="h-6 w-6" />
      </Button>
      <h1 className="text-lg font-semibold ml-2">{props.text}</h1>
    </header>
  )
}

export default MainPage;

export const GetAndroidPage: React.FC = () => {
  return (
    <div className="flex flex-col h-full bg-white md:rounded-panel border shadow-sm overflow-hidden">
      <SimpleHeader />
      <div className="flex-1 overflow-y-auto p-4">
        <div className="space-y-4">
          <h3 className="text-lg font-medium">Download latest test version for Android here</h3>
          <div className="p-3 bg-gray-50 rounded-lg border break-all">
            <a href="https://drive.google.com/drive/u/0/folders/1DVDfVczgKTPjLKUI0EBnLOIOVqqPgO8X" className="text-blue-600 hover:underline">
              https://drive.google.com/drive/u/0/folders/1DVDfVczgKTPjLKUI0EBnLOIOVqqPgO8X
            </a>
          </div>
          <p className="text-sm text-gray-500">Current version is {package_json.version}</p>
        </div>
      </div>
    </div>
  );
};
